import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { GameFontStyle } from "../style/GameFontStyle";
import { Point } from "pixi.js";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { GameLang } from "../lang/GameLang";
/**
 * FullHouseProperties.ts
 */
export class FullHouseProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.animation = new SpineProperties("WinBanners", Modules.GAME);
        this.titleProperties = new TextFieldProperties(GameFontStyle.FULL_HOUSE, new Point(0, -270), GameLang.FULL_HOUSE, ControlConstants.CENTER, ControlConstants.CENTER, new Point(600, 400));
        this.titleProperties.setMultiline(true);
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, false);
    }
}
//# sourceMappingURL=FullHouseProperties.js.map